<template>
    <div>
        <header class="section-header">{{ $t('assignments.details.assessment_detail_header') }}</header>
        <assignment-base-box>
            <ul class="assessment-detail" v-for="assessment in assessments" :key="assessment.id">
                <li>{{ assessment.name }}</li>
            </ul>
        </assignment-base-box>
    </div>
</template>

<script>
import AssignmentBaseBox from '@/components/assignments/AssignmentBaseBox';

export default {
    components: {
        AssignmentBaseBox
    },
    props: {
        assessments: {
            type: Array,
            default: () => []
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
.section-header {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 32px;
    text-transform: uppercase;
    letter-spacing: 0.25px;
    padding: 0 32px;
}

.assessment-detail {
  list-style: none;
  padding: 0;
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: $black;
  margin-bottom: 8px;
}
</style>
